// import { service } from 'services';
import { hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

const mockResponse = async () => [
  {
    id: 3378,
    name: 'Sample key 1',
    key: 'd7:21:c7:d6:b8:3a:29:29:11:ae:6f:79:bc:67:63:56',
    defaultKey: true,
  }, {
    id: 3380,
    name: 'Sample key 2',
    key: 'c4:21:c7:d6:b8:3a:29:29:11:ae:6f:79:bc:67:63:44',
    defaultKey: false,
  }, {
    id: 3384,
    name: 'Sample key 3',
    key: 'a3:21:c7:d6:b8:3a:29:29:11:ae:6f:79:bc:67:63:12',
    defaultKey: false,
  },
];

export default {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.SSH_KEYS.GET_ALL,
    apiResult: mockResponse(), // service.sshKey.getAll(),
    payloadKey: 'sshKeys',
  }),

  // create: async () => { },

  // update: async () => { },

  // delete: async () => { },
};
